import { useMemo, useState } from 'react';

import { debounce, uniqBy } from 'lodash';

import { DispatchTripPayerOrganizationRead } from 'src/common/external/bambi-api/bambiApi';
import { ItemSelector } from 'src/common/ItemSelector/ItemSelector';
import { useDispatchRepository } from 'src/features/dispatch/common/useDispatchRepository';

export default function DispatchCalendarPayerFilter({
  selectedPayers,
  onPayerChange,
}: {
  selectedPayers: DispatchTripPayerOrganizationRead[];
  onPayerChange: (payers: DispatchTripPayerOrganizationRead[]) => void;
}) {
  const { data: dispatchData } = useDispatchRepository();

  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

  const debouncedSetValue = useMemo(
    () => debounce((value: string) => setDebouncedSearchTerm(value), 300),
    []
  );

  const payers = useMemo(() => {
    const assignedTrips = dispatchData?.assigned_trips || [];
    const assignedTripPayers = uniqBy(
      assignedTrips.map((trip) => trip.payer),
      'id'
    ).filter((payer) =>
      payer.display_name
        .toLowerCase()
        .includes(debouncedSearchTerm.toLowerCase())
    );

    return assignedTripPayers;
  }, [dispatchData, debouncedSearchTerm]);

  return (
    <ItemSelector
      items={payers}
      selectedItems={selectedPayers}
      onSelectionChange={onPayerChange}
      onSearchChange={debouncedSetValue}
      searchPlaceholder="Search payers"
      getItemLabel={(payer) => payer.display_name}
      dataTestId="dispatch-calendar-payer-filter"
      noItemsText="No payers found."
    />
  );
}
